<template>
  <path
    d="M19 1.00018H5C3.9 1.00018 3.01 1.90018 3.01 3.00018L3 15.9302C3 16.6202 3.35 17.2302 3.88 17.5902L11.45 22.6302C11.79 22.8502 12.22 22.8502 12.56 22.6302L20.12 17.5902C20.65 17.2302 21 16.6202 21 15.9302V3.00018C21 1.90018 20.1 1.00018 19 1.00018ZM18.3 7.70018L10.71 15.2902C10.32 15.6802 9.69 15.6802 9.3 15.2902L5.71 11.7002C5.32 11.3102 5.32 10.6802 5.71 10.2902C6.1 9.90018 6.73 9.90018 7.12 10.2902L10 13.1702L16.88 6.29018C17.27 5.90018 17.9 5.90018 18.29 6.29018C18.68 6.68018 18.69 7.31018 18.3 7.70018Z"
  />
</template>
